// src/config/tableConfig.js
export const DISABLE_COLUMN_VISIBILITY_FOR = {
  '/master/manage-permission': true,
  '/employee/employee-hierarchy': true,
};
